import React, { useState } from 'react';
import styled from 'styled-components';
import NavBannerDesktop from './common/NavBannerDesktop';
import Navigation from './desktop/Navigation';
import NavigationMobile from './mobile/NavigationMobile';
import SearchWrapper from './SearchWrapper';
import useSale from '@/hooks/useSale';

const Wrapper = styled.div`
  .nav-banner-desktop {
    z-index: 1002;
  }

  @media (max-width: 992px) {
    top: 0;
    background: white;
    position: sticky;
    z-index: 9;
    top: 0px;
    width: 100%;
  }
`;


export default function NavigationContainer() {
  const [showSearch, setShowSearch] = useState(false);
  const { isSale } = useSale();

  return (
    <Wrapper id="navigation">
      <div className="hide-on-mobile">
        {
          isSale && (
            <NavBannerDesktop className="nav-banner-desktop" />
          )
        }
        <Navigation setShowSearch={setShowSearch} />
      </div>
      <div className="hide-on-desktop">
        <NavigationMobile setShowSearch={setShowSearch} />
      </div>
      <SearchWrapper showSearch={showSearch} setShowSearch={setShowSearch} />
    </Wrapper>
  );
}
